import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useCompanyTasksQuery } from 'queries';
import { saveCompanyTasksSagaAction } from '../actions';
import { selectMyCompanyTasks } from '../selectors';

export const useCompanyTasksStore = () => {
  const { data, isLoading, ...rest } = useCompanyTasksQuery();
  const dispatch = useDispatch();
  const result = useSelector(selectMyCompanyTasks, shallowEqual);

  useEffect(() => {
    if (!isLoading) {
      const tasks = data || [];

      dispatch(saveCompanyTasksSagaAction(tasks));
    }
  }, [data, isLoading, dispatch]);

  return {
    data: result,
    isLoading,
    ...rest,
  };
};
